import { render } from "./GmxCardList.vue?vue&type=template&id=bbfd31fc"
import script from "./GmxCardList.vue?vue&type=script&lang=js"
export * from "./GmxCardList.vue?vue&type=script&lang=js"

import "./GmxCardList.vue?vue&type=style&index=0&id=bbfd31fc&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__